import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
import { Search } from '../../shared/user.model';

// import jquery = require("jquery");

// constng $=  jquery;

@Component({
  selector: 'app-chit-creation',
  templateUrl: './chit-creation.component.html',
  styleUrls: ['./chit-creation.component.css']
})
export class ChitCreationComponent implements OnInit {
  title="Chit Creation";
  cc:any={};  
  formInvalid: boolean = false;
 ChitCreationDetailsList: any = {};
  c: any ={}; 
  r: any = {};
  n:any={};
  a:any={};
  aa: any = {};
  CODE: number;
  glsub_id:number;
  
  NomineeDetails : any = [];
  CODE1: number;
  CUSTID: number;
  CHITSCHEME_NO: number;
  BRANCH_ID:number;
  mode: string;  
  AccNolist: any = {}
  Branchlist: any = {}
  Relationlist: any = {}
  Schemelist: any;
  AClist: any= {}
  CustomerDetails: any;
  AgentNamelist: any = {}
  fileToUpload: File = null;
  hide: boolean = false;
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$";
  agepattern = "[1-100]";
  Accountnum = "/^([0-9]{11})|([0-9]{2}-[0-9]{3}-[0-9]{6})$/";
  today: Date;
  itemsPerPage: number=5;
  currentPage: number=1;
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  temp:any={};


  myModalOne;

  mySelect;
  // BRANCH_ID=this.c.BRANCH_ID;
  constructor(private Service: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
  ) { 
    this.s = new Search();
    this.isSearch = false;
  }
   
    CHIT_STDT =  'dd/MM/yyyy';
    
  ngOnInit() {
    this.GetAllData()
    debugger;
   // this.GetChitCreationDetails(this.CHITSCHEME_NO)
    // this.GetToknNo(this.CHITSCHEME_NO);
  }
  //
   ngAfterViewInit() 
   {
   
   }


  //
  
  GetAllData() {
   
    //ddl for branch  
    this.data = this.Service.GetAllBranchs();
    this.data.subscribe(
      (response: any) => {
      this.Branchlist = response;
      console.log('Branches');
        console.log(this.Branchlist);
      })


      this.data = this.Service.GetAllAC();
      this.data.subscribe(
        (response: any) => {
        this.AClist = response;
        console.log('AC');
          console.log(this.AClist);
        })

      this.data = this.Service.GetRelationName();
    this.data.subscribe(
      (response: any) => {
      this.Relationlist = response;
      console.log('Relation');
        console.log(this.Relationlist);
      })

      this.data = this.Service.GetSchemeName();
      this.data.subscribe(
        (response: any) => {
        this.Schemelist = response;
        console.log('scheme');
          console.log(this.Schemelist);
        })
    }


    pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetChitCreationDetails(this.CHITSCHEME_NO);
    }
  onSearch(s: any, itemsPerPage: any, pageNumber: number) {
    throw new Error("Method not implemented.");
  }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetChitCreationDetails(this.CHITSCHEME_NO);
    }
    

    //serach

    onSearchs(s, itemsPerPage: number, pageNo: number,scheme:number) { 
debugger;
      
          this.isSearch = true;
          let searchText = this.s.SearchText;
          let searchCriteria = this.s.SearchCriteria;
          if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
            // swal("Warning!", "Please enter the search criteria and search text.", "warning");
            alert("Warning!" );
          else {
            // document.getElementById('loader-spinner').style.display = "block";
            this.Service.SearchChitCreation(searchCriteria, searchText, itemsPerPage, pageNo,scheme)
              .subscribe(
                (data: any) => {
                  if(data.ChitMemberCreationModel.length!=0){              
                  this.ChitCreationDetailsList = data.ChitMemberCreationModel;
                  this.totalItems = data.TotalItemsCount;
                  this.currentPage = pageNo;
                  // document.getElementById('loader-spinner').style.display = "none";
                }
                else
                {
                // document.getElementById('loader-spinner').style.display = "none";         
                }
                }, (error) => {
                  // document.getElementById('loader-spinner').style.display = "none";
                  if (error.status == 401) {
                    this.errorHandler.handleError(error);
                  }
                  else if (error.status == 400) {
                    // swal('Warning!', error.error.Message, 'warning');
                  }
                });
          }
        }
      
//get fuction

    GetChitCreationDetails(CHITSCHEME_NO){
      debugger;
   
    // this.isSearch = false;
      // document.getElementById('loader-spinner').style.display = "block";
      this.data = this.Service.GetChitCreationDetails(CHITSCHEME_NO);
      this.data.subscribe(
        (response: any) => {
          this.ChitCreationDetailsList = response.ChitMemberCreationModel;
            this.totalItems = response.TotalItemsCount;            
          // console.log('pigmy Deatils');
          console.log(this.ChitCreationDetailsList);    
          // document.getElementById('loader-spinner').style.display = "none";
        },
        // (error) => {
        //   // document.getElementById('loader-spinner').style.display = "none";
        //   if (error.status == 401) {
        //     this.errorHandler.handleError(error);
        //   }
        //   else if (error.status == 400) {
        //     // swal('Warning!', error.error.Message, 'warning');
        //     alert('Warning! error.error.Message' )
        //   }
        // });
      )
    }
    

    Cancel1()
    {
      this.cc.searchText='';
      this.cc.searchName='';
      this.c.BRANCH_ID='';
      this.c.Scheme='';
      this.c.Acc_No='';
      this.c.CHIT_AMT='';
      this.c.NOOFMEM='';
      this.c.REG_FEE='';
      this.c.INST_AMT='';
      this.c.maxToknNo='';
      this.c.CHIT_STDT='';
      this.c.Mode='';




    }
    Cancel(){

      this.n.Name='';
      this.n.CODE='';
      this.n.GENDER='';
      this.n.Age1='';
    }
    AddNomineeDetails(n){  
  
      // console.log('Nominee Details');
      console.log(n)
      //let bool = 0;     
      //if (a.AccusedName == "") { bool = 1 }
      if ((n.Name != null || n.Name != undefined)  && (n.CODE != null || n.CODE != undefined)  
     && (n.GENDER != null || n.GENDER != undefined) &&(n.Age1 != null || n.Age1 != undefined) ) {
      this.temp = {
        Name : n.Name,
        NAME_DESC: this.getrelation(n.CODE),
        GENDER: n.GENDER, 
        Age1: n.Age1,
            }  
    
            this.NomineeDetails.push(this.temp);
        this.n = {};
          }
       
      // else {
      //   swal('warning', 'Please enter mandatory fields!', 'warning');        
      // }      
    }   
    getrelation(relcode:number)
    {
      let relname;
      for(let i=0;i<this.Relationlist.length;i++)
      {
        if(relcode==this.Relationlist[i].CODE)
        {
          relname=this.Relationlist[i].NAME_DESC;
        }
      }
      debugger;
      return relname;
    }
      
    // GetAccNo1(CUSTID) {
    //   debugger;
    //   this.data = this.Service.GetAccNo1(CUSTID);
    //   this.data.subscribe(
    //     (response: any) => {
    //       this.c.AC_NO = response.AC_NO;
    //       // this.AccNolist = response;
    //     })
    //   }

    GetCustName (CUSTID) {
  
      this.data = this.Service.GetCustName(CUSTID);
      this.data.subscribe(
        (response: any) => {
          this.c.CUSNAME = response.CUSNAME;
        })
    }    
 

    GetNoOfMemb(CHITSCHEME_NO) {
  
      this.data = this.Service.GetNoOfMemb(CHITSCHEME_NO);
      this.data.subscribe(
        (response: any) => {
          this.c.NOOFMEM = response.NOOFMEM;
        })
    }
    GetSchemeAmt(CHITSCHEME_NO) {
  
      this.data = this.Service.GetSchemeAmt(CHITSCHEME_NO);
      this.data.subscribe(
        (response: any) => {
          this.c.CHIT_AMT = response.CHIT_AMT;
        })
    }
    GetChitDate(CHITSCHEME_NO) {
  
      this.data = this.Service.GetChitDate(CHITSCHEME_NO);
      this.data.subscribe(
        (response: any) => {
          this.c.CHIT_STDT = response.CHIT_STDT;
          if (this.c.CHIT_STDT != null)
          this.c.CHIT_STDT = ((this.c.CHIT_STDT).split('T'))[0];

        })
    }
    
    GetRegFee(CHITSCHEME_NO) {
  
      this.data = this.Service.GetRegFee(CHITSCHEME_NO);
      this.data.subscribe(
        (response: any) => {
          this.c.REG_FEE = response.REG_FEE;
        })
    }


    GetToknNo(CHITSCHEME_NO) {
  
      this.data = this.Service.GetToknNo(CHITSCHEME_NO);
      this.data.subscribe(
        (response: any) => {
          this.c.maxToknNo = response.maxToknNo;
        })
    }
    GetInstAmt(CHITSCHEME_NO) {
  
      this.data = this.Service.GetInstAmt(CHITSCHEME_NO);
      this.data.subscribe(
        (response: any) => {
          this.c.INST_AMT = response.INST_AMT;
        })
    }

//subledger

GetSubLedger(CHITSCHEME_NO,BRANCH_ID) {
      
     
  
  this.data = this.Service.GetSubLedger1(CHITSCHEME_NO,BRANCH_ID);
  this.data.subscribe(
    (response: any) => {
      this.c.Acc_No = response.Acc_No;
      console.log('accno');
      console.log(this.c.Acc_No);
      console.log(BRANCH_ID);
    })
}

    //acc no
   

    GetAccNo1(CHITSCHEME_NO,BRANCH_ID) 
    {
      
     
  
      this.data = this.Service.GetAccountNo(CHITSCHEME_NO,BRANCH_ID);
      this.data.subscribe(
        (response: any) => {
          this.c.Acc_No = response.Acc_No;
          console.log('accno');
          console.log(this.c.Acc_No);
          console.log(BRANCH_ID);
        })
    }

    SaveChitCreation(ChitCreation: NgForm) {
     
     
      ChitCreation.value.NomineeModel=this.NomineeDetails 
      console.log('ChitCreation Forms');
      console.log(ChitCreation.value);
      // ChitCreation.value.Name=ChitCreation.value.Name;
      ChitCreation.value.CUSTID=ChitCreation.value.searchText;
      ChitCreation.value.CUSNAME=ChitCreation.value.searchName
      // if (ChitCreation.invalid) {
      //   // this.formInvalid = true;
      //  // swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      //   // return;
      // }
  
     
        console.log('Data');
        console.log(ChitCreation.value);     
      this.data = this.Service.PostChitCreation(ChitCreation.value);
      this.data.subscribe(
        (response) => {
          ChitCreation.reset();
          ChitCreation.resetForm();
          ChitCreation.form.markAsPristine();
          ChitCreation.form.markAsUntouched();
          swal('Success!', 'Chit Member added Successfully .', 'success');
         // this.router.navigate(['/home/UnicoreMaster1/PigmyAgent']);
          // document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          // document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            // swal('Warning!', error.error.Message, 'warning');
          }
        });
  
      
        
    }
  

    //delete main
    ChitCreationDetailsremove(i){ 
      swal({
        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      })     
      this.ChitCreationDetailsList.splice(i, 1);      
     } 

    //  delete row
 NomineeDetailsremove(i){ 
  swal({
    title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
  })     
  this.NomineeDetails.splice(i, 1);      
 }  
    GetGenderName (CODE) {
  
      this.data = this.Service.GetGenderName(CODE);
      this.data.subscribe(
        (response: any) => {
          this.n.GENDER = response.GENDER;
        })
    }
    GetDetails(CUSTID,CUSNAME){
debugger; 
      this.cc.searchText=CUSTID;
      this.cc.searchName=CUSNAME;
      this.GetCustName(CUSTID);   
      //this.GetAccNo1(CUSTID);
      this.CustomerDetails=[];
    }

    GetCustomerDetails(SearchValue: any, SearchName: any) {    
   debugger;
      if (SearchValue == "" && SearchName == "") {
          this.CustomerDetails = null;
          return
      }
      if (SearchValue == "" || SearchValue == undefined) { SearchValue = "empty" } if (SearchName == "" || SearchName == undefined) { SearchName = "empty" }
      this.Service.GetCustomerDetails1(SearchValue, SearchName)
          .subscribe(
              (data: any) => {
                  this.CustomerDetails = data;
              }, (error) => {
                  this.errorHandler.handleError(error);
              });
  }


  reset()
  {
    this.c.BRANCH_ID='';
    this.cc.searchText='';
    this.cc.searchName='';
    this.c.Scheme='';
    this.c.Acc_No='';
    this.c.CHIT_AMT='';
    this.c.NOOFMEM='';
    this.c.REG_FEE='';
    this.c.INST_AMT='';
    this.c.maxToknNo='';
    this.c.CHIT_STDT='';
    this.c.Mode='';
    this.n.Name='';
    this.n.CODE='';
    this.n.GENDER='';
    this.n.Age1='';
    this.NomineeDetails='';
    
  }
    
}



// WEBPACK FOOTER //
// ./src/app/chitfund/chit-creation/chit-creation.component.ts